import PropTypes from "prop-types"

import { cn } from "styles/utils"

export const Text = ({ className = "", subtitle, ...props }) => (
  <p
    className={cn(
      "text-neutral text-14 tablet:text-16 leading-18 [&_a]:text-primary mb-16 last:mb-0 [&_a]:font-normal [&_b]:font-semibold",
      subtitle ? "font-bold" : "font-light",
      className
    )}
    {...props}
  />
)
Text.propTypes = {
  className: PropTypes.string,
  subtitle: PropTypes.bool,
}

export default Text
